import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function tasksStatusAvailableReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_TASKS_STATUS_AVAILABLE_INIT:
      return { ...state, items: [], error: null, isLoading: true };

    case types.GET_TASKS_STATUS_AVAILABLE_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_TASKS_STATUS_AVAILABLE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
